import { useSeniorMode } from "@/contexts/SeniorModeContext";
import { Eye, EyeOff } from "lucide-react";

export default function SeniorModeToggle() {
  const { seniorMode, toggleSenior, isSeniorAdmin } = useSeniorMode();

  if (!isSeniorAdmin) return null;

  return (
    <button
      onClick={toggleSenior}
      className="senior-mode-indicator no-print"
      data-testid="senior-mode-toggle"
      title={seniorMode ? "Disable Senior Mode" : "Enable Senior Mode (larger text)"}
    >
      {seniorMode ? <EyeOff size={20} /> : <Eye size={20} />}
      {seniorMode ? "Normal View" : "Senior View"}
    </button>
  );
}
